<div class="lp-drag-and-drop-activity" style="position: relative; width: 100%; height: 100%">
  <app-canvas-renderer
    [elements]="elements()"
    [overrides]="overrides()"
    [size]="size()"
    style="display: block; width: 100%; height: 100%"
    (grabbed)="grab($event)"
    (dragged)="drag($event)"
    (dropped)="drop($event)"
  />

  @if (!automaticContinue()) {
    <app-hud-button [isDisabled]="!canContinue()" style="display: block; position: absolute; right: 1em; bottom: 1em" (click)="continue()"
      >Ga verder</app-hud-button
    >
  }
</div>
